import { render } from "./WallPage.vue?vue&type=template&id=6a698832"
import script from "./WallPage.vue?vue&type=script&lang=js"
export * from "./WallPage.vue?vue&type=script&lang=js"

import "./WallPage.vue?vue&type=style&index=0&id=6a698832&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__